// libs
import { css } from "@emotion/core";

// constants
import { FONTS } from "shared/styles/base";

export const modal_content = css`
    @media (max-width: 768px) {
        width: 100%;
        max-width: 100%;
        height: 100%;
        max-height: 100%;
        overflow: hidden;
    }

    .modal_content_wrapper {
        width: 720px;
        padding: 25px 40px;
        font: normal 14px/19px ${FONTS.CERA};
        color: #000;

        @media (max-width: 768px) {
            width: 100%;
            font: normal 12px/16px ${FONTS.CERA};
            padding: 25px;
        }

        .modal_content {
            @media (max-width: 768px) {
                overflow-y: auto;
                height: calc(100% - 70px);
                position: fixed;
                padding: 25px;
                bottom: 0;
                left: 0;
            }
        }

        .logo {
            width: 74px;
            height: 35px;
            display: inline-block;
            margin-bottom: 18px;
            @media (max-width: 768px) {
                width: 59px;
                height: 28px;
                display: block;
                margin: 0 auto 20px;
            }
        }

        .heading {
            margin: 0 0 20px 0;
            font-weight: 500;
            @media (max-width: 768px) {
                text-align: center;
            }
        }

        .listHeading {
            margin: 0;
            font-weight: bold;
            @media (max-width: 768px) {
                margin-top: 18px;
            }
        }

        .dropdown {
            margin-bottom: 18px;
        }

        .countries {
            margin: 10px 0 20px 0;
            @media (max-width: 768px) {
                text-align: center;
            }
        }

        .title {
            margin: 20px 0;
        }

        .btn-fullwidth {
            width: 100%;
            background: #000;
            color: #fff;
            font-weight: bold;
            text-transform: uppercase;
            height: 45px;
            border-radius: 2px;
            border: 0;
            outline: 0;
            cursor: pointer;
            display: flex;
            align-items: center;
            justify-content: center;
            margin: 0 0 10px 0;
        }

        .moreLink {
            text-decoration: underline;
            cursor: pointer;
        }

        .modal_content:after {
            content: "";
            clear: both;
            display: table;
        }

        .shippingInfo {
            padding-left: 25px;
            margin: 25px 0 0 0;
            list-style: none;
            li {
                position: relative;
                margin-bottom: 5px;
                &:before {
                    content: "";
                    width: 3px;
                    height: 3px;
                    position: absolute;
                    border-radius: 50%;
                    left: -25px;
                    top: 8px;
                    background: #000;
                }
            }
        }

        .label {
            font-weight: 500;
            display: block;
            margin-bottom: 8px;
            color: #393939;
        }

        p {
            margin: 0;
        }

        .modal_content_section {
            float: left;
            width: 320px;

            &:first-of-type {
                padding-right: 40px;
                border-right: 1px solid #cccccc;
            }

            &:last-of-type {
                padding-left: 35px;
            }

            @media (max-width: 768px) {
                float: none;
                width: 100%;

                &:first-of-type {
                    padding-right: 0;
                    border-right: none;
                }

                &:last-of-type {
                    padding-left: 0;
                }
            }
        }
    }
`;
